import { z } from 'zod';

// Zod 4 words a missing value as "Invalid input: expected string, received undefined".
// A schema's own message still takes priority over this.
z.config({ customError: (issue) => (issue.input === undefined ? 'Required' : undefined) });
